// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"2417":"fc34d772","32095":"ce0dd5ce","56238":"b38ce23f","79467":"9e71e15c"}[chunkId] + ".css";
};